import React from 'react'

import idx from 'idx'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import SubmitButton from 'components/atoms/buttons/SubmitButton'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as trapModule from 'modules/trap'

const styles = theme => ({
  root: {
    width: 424,
    textAlign: 'center',
  },
  description: {
    margin: `${theme.spacing(2)}px 0 ${theme.spacing(4)}px`,
  },
  actions: {
    maxWidth: 360,
    display: 'flex',
    margin: '0 auto',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
})

class DeleteTrapConfirm extends React.Component {
  onCancelClick = () => {
    this.props.handleClose()
  };

  onConfirmClick = () => {
    this.props.data.onConfirm()
  };

  render() {
    const { classes } = this.props

    return (
      <div className={classes.root}>
        <Typography variant="h1">Delete trap</Typography>
        <div className={classes.description}>
          <Typography>Are you sure you want to delete this trap?</Typography>
          <Typography>You will no longer be able to access it.</Typography>
        </div>
        <div className={classes.actions}>
          <SubmitButton
            size="medium"
            color="primary"
            variant="secondary"
            onClick={this.onCancelClick}>
            Cancel
          </SubmitButton>
          <SubmitButton
            size="medium"
            color="primary"
            variant="primary"
            onClick={this.onConfirmClick}>
            Confirm
          </SubmitButton>
        </div>
      </div>
    )
  }
}

DeleteTrapConfirm.propTypes = {
  data: PropTypes.object,
  classes: PropTypes.object,
  actions: PropTypes.object,
  handleClose: PropTypes.func,
  organisation: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    organisation: idx(state, _ => _.organisation.selected) || {},
  }
}

function mapDispatchToProps(dispatch) {
  const actions = Object.assign({}, trapModule)
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(DeleteTrapConfirm))



// WEBPACK FOOTER //
// ./src/components/molecules/DeleteTrapConfirm.js